import { BOMStepOneComponent } from './../bom-step-one/bom-step-one.component';
import { RdBoM, RdBoMBtp, RdBoMCt, RdBomNSNC, RdBomNSTBThietBi } from './../../cong-thuc-dinh-muc/cong-thuc-dinh-muc-model/cong-thuc-dinh-muc.model';
import { LoopGiaiDoan, StateBOM, TreeBTP, __DEFAULT__DSP } from './../bom-model/bom.model';
import { stat } from 'fs';
import { select } from '@ngrx/store';
import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	HostListener,
	ViewRef
}
	from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatStepper, MatTabChangeEvent } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { BOMService } from '../bom-service/bom.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { FlexAlignStyleBuilder } from '@angular/flex-layout';
import { BOM, BOMCt } from '../bom-model/bom.model';
import { BOMStepTwoComponent } from '../bom-step-two/bom-step-two.component';
import { BOMStepThreeComponent } from '../bom-step-three/bom-step-three.component';
import { BOMStepFourComponent } from '../bom-step-four/bom-step-four.component';
import { QuyTrinhSanXuatService } from '../../quy-trinh-san-xuat/quy-trinh-san-xuat-service/quy-trinh-san-xuat.service';
import { QuyTrinhSanXuatPageService } from '../../quy-trinh-san-xuat-page/quy-trinh-san-xuat-page-service/quy-trinh-san-xuat-page.service';


@Component({
	selector: 'kt-bom-detail-dialog',
	templateUrl: './bom-detail-dialog.component.html',
	styleUrls: ['../bom.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class BOMDetailDialogComponent implements OnInit {
	CONFIG: CommonConFig;
	displayedColumnsAll: string[] = ['code', 'name', 'weight', 'unit'];
	displayedColumns: string[] = ['type', 'code', 'name', 'weight', 'unit', 'isjoin', 'action'];
	// ARRAY DATA
	fullDataAPI = null;
	allProcess = new BehaviorSubject<any[]>([]);
	eachStage = new BehaviorSubject<any[]>([]);
	master = null;
	TinhTrang = StateBOM;
	// CONSTANT
	btnExportBOM = new BehaviorSubject<boolean>(false);
	req_quantification = 0;
	id_bom = 0;
	url_current = "chi-tiet";
	// FORM
	FormXemXet: FormGroup;
	FormPheDuyet: FormGroup;
	FormGDKDuyet: FormGroup;
	MainForm: FormGroup;
	// TOOL
	zoomIn : boolean = true;
	// LIST DATA API
	listTypeOfMerchandise = [];
	listMerchandises = [];
	listUnit = [];
	listStage = [];
	listDevice = [];
	listQTSX = [];
	listProductionArea = [];
	dataSources = [{},{},{},{},{}];
	//
	loadingData = new BehaviorSubject<boolean>(true);
	loadingMer = new BehaviorSubject<boolean>(true);

	loadingCaculate = new BehaviorSubject<boolean>(false);
	constructor(
		private bom: BOMService,
		private DungChungService: DungChungService,
		private MainFormFB: FormBuilder,
		private FormBanThanhPhamFB: FormBuilder,
		private FormXacNhanFB: FormBuilder,
		private FormDuyetFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private subheaderService: SubheaderService,
		private router: Router,
		private route: ActivatedRoute,
		public dialogRef: MatDialogRef<BOMDetailDialogComponent>,
		public dialog: MatDialog,
		private serviceQTSX: QuyTrinhSanXuatService,
		private serviceQTSXs: QuyTrinhSanXuatPageService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {

	}

	/** LOAD DATA */
	async ngOnInit() {
		this.CONFIG = new CommonConFig();
		let breadcrumbs = [{ title: 'R&D' }, { title: 'Công thức định mức', page: '/cong-thuc-dinh-muc' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);
		this.initForm();
		if (this.data.IdBOM && this.data.IdBOM > 0) {
			let breadcrumbs = [];
			breadcrumbs = [{ title: 'RD' }, { title: 'Công thức định mức', page: '/cong-thuc-dinh-muc' }, { title: 'Chi tiết', page: '/cong-thuc-dinh-muc/chi-tiet/'+this.data.IdBOM }];
			this.subheaderService.setBreadcrumbs(breadcrumbs);
			this.bom.viewTree(this.data.IdBOM).subscribe(res => {
				if(!res || res.status == 0 || (res.data.TinhTrang_Code == this.TinhTrang[7].value))
				{
					this.back();
					return false;
				}
				let data = res.data.data;
				this.addConfirm(res.data.confirm);
				this.fullDataAPI = {...data};
				this.req_quantification = data.weight;
				this.handleCaculate(data.weight);
				this.getListMerchandise();
				this.changeDetect.detectChanges();
			});
		}else{
			this.back();
		}
	}
	validRole(url: string, role: boolean = false){
		if(url == 'xem-xet' || url == 'phe-duyet' || url == 'gdk-duyet')
			return role;
		return true;
	}

	invalidUrl(state: string, url: string){
		return (state != this.TinhTrang[0].value && url == 'chinh-sua')
		|| (state != this.TinhTrang[1].value && url == 'xem-xet')
		|| (state != this.TinhTrang[3].value && url == 'phe-duyet')
		|| (state == this.TinhTrang[7].value && url == 'chi-tiet')
		|| (state != this.TinhTrang[9].value && url == 'gdk-duyet')
	}

	addConfirm(_confirm: any){
		if(this.url_current == 'chi-tiet'){
			this.MainForm.disable();
			this.FormXemXet.controls['NGAYXEMXET'].setValue(_confirm && _confirm[0] ? _confirm[0].date : null);
			this.FormXemXet.controls['NGUOIXEMXET'].setValue(_confirm && _confirm[0] ? _confirm[0].user : null);
			this.FormXemXet.controls['KQXEMXET'].setValue(_confirm && _confirm[0] ? _confirm[0].result : null);
			this.FormXemXet.controls['GHICHU'].setValue(_confirm && _confirm[0] ? _confirm[0].reason : null);
			this.FormPheDuyet.controls['NGAYPHEDUYET'].setValue(_confirm && _confirm[1] ? _confirm[1].date : null);
			this.FormPheDuyet.controls['NGUOIPHEDUYET'].setValue(_confirm && _confirm[1] ? _confirm[1].user : null);
			this.FormPheDuyet.controls['KQPHEDUYET'].setValue(_confirm && _confirm[1] ? _confirm[1].result : null);
			this.FormPheDuyet.controls['GHICHU'].setValue(_confirm && _confirm[1] ? _confirm[1].reason : null);
			this.FormGDKDuyet.controls['NGAYPHEDUYET'].setValue(_confirm && _confirm[2] ? _confirm[2].date : null);
			this.FormGDKDuyet.controls['NGUOIPHEDUYET'].setValue(_confirm && _confirm[2] ? _confirm[2].user : null);
			this.FormGDKDuyet.controls['KQPHEDUYET'].setValue(_confirm && _confirm[2] ? _confirm[2].result : null);
			this.FormGDKDuyet.controls['GHICHU'].setValue(_confirm && _confirm[2] ? _confirm[2].reason : null);
		}
		if(this.url_current == 'xem-xet' || this.url_current == 'phe-duyet' || this.url_current == 'gdk-duyet'){
			this.MainForm.disable();
			if(this.FormXemXet != null){
				if(this.url_current != 'xem-xet' ){
					if(_confirm && _confirm.length > 0){
						this.FormXemXet.controls['NGAYXEMXET'].setValue(_confirm[0].date);
						this.FormXemXet.controls['NGUOIXEMXET'].setValue(_confirm[0].user);
						this.FormXemXet.controls['KQXEMXET'].setValue(_confirm[0].result);
						this.FormXemXet.controls['GHICHU'].setValue(_confirm[0].reason);
					}
					this.FormXemXet.disable();
				}
				if(this.url_current == 'xem-xet'){
					this.FormXemXet.controls['KQXEMXET'].setValue("");
					this.FormXemXet.controls['GHICHU'].enable();
				}
			}
			if(this.FormPheDuyet != null){
				if(this.url_current != 'phe-duyet' ){
					if(_confirm && _confirm.length > 1){
						this.FormPheDuyet.controls['NGAYPHEDUYET'].setValue(_confirm[1].date);
						this.FormPheDuyet.controls['NGUOIPHEDUYET'].setValue(_confirm[1].user);
						this.FormPheDuyet.controls['KQPHEDUYET'].setValue(_confirm[1].result);
						this.FormPheDuyet.controls['GHICHU'].setValue(_confirm[1].reason);
					}
					this.FormPheDuyet.disable();
				}
				if(this.url_current == 'phe-duyet'){
					this.FormPheDuyet.controls['GHICHU'].enable();
				}
			}

			if(this.FormGDKDuyet != null){
				if(this.url_current != 'gdk-duyet' ){
					if(_confirm && _confirm.length > 2){
						this.FormGDKDuyet.controls['NGAYPHEDUYET'].setValue(_confirm[2].date);
						this.FormGDKDuyet.controls['NGUOIPHEDUYET'].setValue(_confirm[2].user);
						this.FormGDKDuyet.controls['KQPHEDUYET'].setValue(_confirm[2].result);
						this.FormGDKDuyet.controls['GHICHU'].setValue(_confirm[2].reason);
					}
					this.FormGDKDuyet.disable();
				}
				if(this.url_current == 'gdk-duyet'){
					this.FormGDKDuyet.controls['GHICHU'].enable();
				}
			}
		}
	}

	addBreadCrumbs(url: string, id: number){
		let breadcrumbs = [{ title: 'RD' }, { title: 'Công thức định mức', page: '/cong-thuc-dinh-muc' }, ];
		if(url == "chinh-sua"){
			breadcrumbs = [...breadcrumbs, { title: 'Chỉnh sửa', page: '/cong-thuc-dinh-muc/chinh-sua/' + id }];
		}

		if(url == "chi-tiet"){
			breadcrumbs = [...breadcrumbs, { title: 'Chi tiết', page: '/cong-thuc-dinh-muc/chi-tiet/' + id }];
		}

		if(url == "xem-xet"){
			breadcrumbs = [...breadcrumbs, { title: 'Xem xét', page: '/cong-thuc-dinh-muc/xem-xet/' + id }];
		}

		if(url == "phe-duyet"){
			breadcrumbs = [...breadcrumbs, { title: 'Phê duyệt', page: '/cong-thuc-dinh-muc/phe-duyet/' + id }];
		}

		if(url == "gdk-duyet"){
			breadcrumbs = [...breadcrumbs, { title: 'Giám đốc khối duyệt', page: '/cong-thuc-dinh-muc/gdk-duyet/' + id }];
		}

		this.subheaderService.setBreadcrumbs(breadcrumbs);
	}

	initForm(){
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		// Main Form
		this.MainForm = this.MainFormFB.group({
			NGAYLAP: [new Date()],
			NGUOILAP: [tenNguoiLap],
		});

		// Form Xem Xet
		this.FormXemXet = this.MainFormFB.group({
			NGAYXEMXET  : [{value : new Date(), disabled: true}],
			NGUOIXEMXET : [{value : tenNguoiLap, disabled: true}],
			KQXEMXET 	: [{value : "", disabled: true}],
			GHICHU		: [{value : "", disabled: false}],
		});

		// Form Phê duyệt
		this.FormPheDuyet = this.MainFormFB.group({
			NGAYPHEDUYET  : [{value : new Date(), disabled: true}],
			NGUOIPHEDUYET : [{value : tenNguoiLap, disabled: true}],
			KQPHEDUYET 	  : [{value : "", disabled: true}],
			GHICHU		  : [{value : "", disabled: false}],
		});

		// Form GĐK duyệt
		this.FormGDKDuyet = this.MainFormFB.group({
			NGAYPHEDUYET  : [{value : new Date(), disabled: true}],
			NGUOIPHEDUYET : [{value : tenNguoiLap, disabled: true}],
			KQPHEDUYET 	  : [{value : "", disabled: true}],
			GHICHU		  : [{value : "", disabled: false}],
		});
	}

	handleCaculate(evt: any, setChildNull: boolean = true){
		if(!Number(evt)) return;
		let newData = {...this.fullDataAPI};
		delete newData.childs;
		this.master = {...newData};
		this.MainForm.controls['NGUOILAP'].setValue(this.master['creator']);
		this.MainForm.controls['NGAYLAP'].setValue(this.master['date'] ? this.master['date'] : new Date());
		this.eachStage.next([]);
		this.allProcess.next([]);
		this.handleEachStage({...this.fullDataAPI }, Number(evt), setChildNull);
		this.eachStage.value.sort((a, b) => {return b.prior - a.prior});
		this.eachStage.value.forEach(x =>
		{
			x.parent = true;
			if(this.allProcess.value.length > 0) this.allProcess.value.push({...x});
			if(x.childs) x.childs.forEach(a => this.allProcess.value.push({...a}));
		});
		console.log(this.eachStage.value);
		this.allProcess.next([...this.allProcess.value]);
		this.allProcess.value.forEach(x => {if(x.childs) delete x.childs;});
		this.changeDetect.detectChanges();
	}

	tabChanged(tabChangeEvent: MatTabChangeEvent){
		if(tabChangeEvent.index == 0){
			this.req_quantification = Number(this.eachStage.value[0].weight);
			this.initBOMFullProcess();
			this.changeDetect.detectChanges();
			return;
		}
	}

	initBOMFullProcess(){
		//alert(this.req_quantification);
		let _newMaster = {};
		this.allProcess.next([]);
		let _newEachProcess = [...this.eachStage.value.sort((a, b) => {return b.prior - a.prior})];
		_newEachProcess.forEach((_partial, _index) => {
			_partial.parent = true;
			if(_index == 0) _partial.balance = +this.req_quantification;
			if(this.allProcess.value.length > 0)
				this.allProcess.value.push({..._partial});
			if(_partial.childs)
				_partial.childs.forEach(child => {
					let _newChild = {...child};
					_newChild.balance = _partial.batch_quantification  == 0 ? 0 : Number((child.weight / _partial.batch_quantification * _partial.balance));
					this.allProcess.value.push({..._newChild});
					if(child.childs && child.childs.length > 0){
						let _nodeChild = _newEachProcess.find(_node => _node.idBTP == child.idBTP);
						 _nodeChild.balance = _nodeChild ? _newChild.balance : 0;
					}
				});
			if(_index == 0){
				_newMaster = {..._partial};
				delete _newMaster["childs"];
			}
		})
		this.allProcess.value.forEach(x => {if(x.childs) delete x.childs;});
		this.allProcess.next([...this.allProcess.value]);
		this.master = {..._newMaster};
		this.changeDetect.detectChanges();
	}

	handleEachStage(object: any, newBalance: number, setChildNull: boolean = true){
		if(object.childs == null) return;
		let newObject = FunctionPublic.cloneObject(object);
		if(object.childs.length == 0){
			//Nếu như childs = [] thì vẫn tạo BOM từng công đoạn
			newObject.childs = setChildNull ? null : [];
			this.eachStage.value.push({...newObject});
			this.eachStage.next(this.eachStage.value);
		}else{
			
			let sumChildsExchange = newObject.childs.filter(x => x.calc_performance && x.calc_performance).map(x => Number(x.exchange)).reduce((a, b) => {return a + b;},0);
			let sumChilds = newObject.childs.map(x => Number(x.weight)).reduce((a, b) => {return a + b;},0);
			// Tính định lượng mẻ
			if(newObject.flagCT)
				newObject.batch_quantification = sumChilds / this.fWeightBatch(newObject.childs);
			else
				newObject.batch_quantification = this.eachStage.value.length == 0 ? newObject.weight : (sumChildsExchange * Number(newObject.performance) / 100.0);

			// Tính toán
			newObject.childs.forEach(child => {
				child.balance = newObject.batch_quantification  == 0 ? 0 : Number((child.weight / newObject.batch_quantification * newBalance));
				child.keyListTypeOf = "";
				child.keyListMer = "";
				child.keyListQTSX = "";
				child.keyListUnit = "";
				child.ListUnit = [];
				child.isClick = false;
				//this.updateCodeNameMer(child);
			});
			newObject.keyListMer = "";
			newObject.keyListQTSX = "";
			newObject.keyListDevice = "";
			newObject.devices = newObject.devices.map(x => ''+x);

			// Thêm vào
			var index = this.eachStage.value.findIndex(a => a.idMer == newObject.idMer);
			if(index > -1)
			{
				this.eachStage.value[index].childs.forEach(_item => {
					let newObjectItem = newObject.childs.find(_ch => _ch.idMer == _item.idMer);
					if(newObjectItem != null) _item.balance += newObjectItem.balance;
				});
			}
			else
			{
				this.eachStage.value.push({...newObject});
				this.eachStage.next(this.eachStage.value);
			}

			// Chạy đệ quy
			newObject.childs.forEach(child =>{

				if(child.childs != null)
					this.handleEachStage(child, child.balance);
			});
		}
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}

	getTitle(): string {
		if (this.url_current == 'them-moi') return 'THÊM MỚI ĐỊNH MỨC NGUYÊN VẬT LIỆU';
		if (this.url_current == 'chinh-sua') return 'CHỈNH SỬA ĐỊNH MỨC NGUYÊN VẬT LIỆU';
		if (this.url_current == 'chi-tiet') return 'CHI TIẾT ĐỊNH MỨC NGUYÊN VẬT LIỆU';
		if (this.url_current == 'xem-xet') return 'XEM XÉT ĐỊNH MỨC NGUYÊN VẬT LIỆU';
		if (this.url_current == 'phe-duyet') return 'PHÊ DUYỆT ĐỊNH MỨC NGUYÊN VẬT LIỆU';
		if (this.url_current == 'gdk-duyet') return 'GÍAM ĐỐC KHỐI DUYỆT ĐỊNH MỨC NGUYÊN VẬT LIỆU';
	}

	getFormatDate(v: string = "") {
		if (v != "") {
			return v.includes("T")
				? v.replace(
						/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g,
						"$5/$3/$1"
				  )
				: v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}

	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}

	f_number_four(item: any = "0.0000"){
		return FunctionPublic.displayFourPoint(item);
	}

	fCaculate(child: any){
		let result = 0;
		let _parentID = child.semiProduct;
		let _infoParent = this.eachStage.value.find(x => x.idOrder == _parentID);
		let _listTemp = [this.master, ...this.allProcess.value];
		let _parentOfItSelf = _listTemp.find(x => !x.parent && x.idOrder == _parentID);
		let value = _parentOfItSelf && _parentOfItSelf.quantitative_batch ? _parentOfItSelf.quantitative_batch : 0;
		result = _infoParent ? (value * child.mass / _infoParent.quantitative_batch) : 0;
		return result;
	}

	// nunununununununununununununununununununununununununununununun
	exportBOM(_id){
		this.btnExportBOM.next(true);
		this.bom.exportBOM(_id).subscribe(blob => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = "BOM_EXPORT_" + moment(new Date).format('YYYYMMDDHHmm');
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
			this.btnExportBOM.next(false);
			this.changeDetectView();
		});
	}

	fWeightBatch(childs: any[]){
		if(!childs || childs.length == 0) return 0;
		return childs.map(x => Number(x.weight)).reduce((a, b) => {return a + b},0);
	}

	Duyet(status: boolean) {
		let formGroup;
		formGroup = this.FormPheDuyet;
		let controls = formGroup.controls;
		if (status === false) {
			if (formGroup.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				this.layoutUtilsService.showErorr("Vui lòng nhập lý do không duyệt");
				return;
			}
		}
		const _sophieu = this.master['bOMNumber'];
		if (status) {
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				formGroup.controls['GHICHU'].clearValidators();
				formGroup.controls['GHICHU'].updateValueAndValidity();
				var data = {
					BOMID 		: this.id_bom,
					LOAITHAOTAC : this.TinhTrang[9].value,
					NOIDUNG		: controls['GHICHU'].value ? controls['GHICHU'].value : ""
				};
				this.bom.confirm(data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		} else {
			if(!controls['GHICHU'].value){
				controls['GHICHU'].setValidators([Validators.required]);
				controls['GHICHU'].updateValueAndValidity();
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				window.scroll({top: document.body.scrollHeight, behavior: 'smooth' });
				this.layoutUtilsService.showErorr("Vui lòng nhập lý do không duyệt");
				return;
			}
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				var data = {
					BOMID 		: this.id_bom,
					LOAITHAOTAC : this.TinhTrang[5].value,
					NOIDUNG		: controls['GHICHU'].value ? controls['GHICHU'].value : ""
				};
				this.bom.confirm(data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		}
	}

	XacNhan(status: boolean) {
		let formGroup;
		formGroup = this.FormXemXet;
		let controls = formGroup.controls;
		if (status === false) {
			if (formGroup.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				this.layoutUtilsService.showErorr("Vui lòng nhập lý do không xem xét");
				return;
			}
		}
		const _sophieu = this.master['bOMNumber'];
		if (status) {
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				formGroup.controls['GHICHU'].clearValidators();
				formGroup.controls['GHICHU'].updateValueAndValidity();
				var data = {
					BOMID 		: this.id_bom,
					LOAITHAOTAC : this.TinhTrang[3].value,
					NOIDUNG		: controls['GHICHU'].value ? controls['GHICHU'].value : ""
				};
				this.bom.accept(data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		} else {
			if(!controls['GHICHU'].value){
				controls['GHICHU'].setValidators([Validators.required]);
				controls['GHICHU'].updateValueAndValidity();
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				window.scroll({top: document.body.scrollHeight, behavior: 'smooth' });
				this.layoutUtilsService.showErorr("Vui lòng nhập lý do không duyệt");
				return;
			}
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				var data = {
					BOMID 		: this.id_bom,
					LOAITHAOTAC : this.TinhTrang[2].value,
					NOIDUNG		: controls['GHICHU'].value ? controls['GHICHU'].value : ""
				};
				this.bom.accept(data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});
		}
	}

	GDKDuyet(status: boolean) {
		let formGroup;
		formGroup = this.FormGDKDuyet;
		let controls = formGroup.controls;
		if (status === false) {
			if (formGroup.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				this.layoutUtilsService.showErorr("Vui lòng nhập lý do không duyệt");
				return;
			}
		}
		const _sophieu = this.master['bOMNumber'];
		if (status) {
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				formGroup.controls['GHICHU'].clearValidators();
				formGroup.controls['GHICHU'].updateValueAndValidity();
				var data = {
					BOMID 		: this.id_bom,
					LOAITHAOTAC : this.TinhTrang[4].value,
					NOIDUNG		: controls['GHICHU'].value ? controls['GHICHU'].value : ""
				};
				this.bom.gdkconfirm(data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		} else {
			if(!controls['GHICHU'].value){
				controls['GHICHU'].setValidators([Validators.required]);
				controls['GHICHU'].updateValueAndValidity();
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				window.scroll({top: document.body.scrollHeight, behavior: 'smooth' });
				this.layoutUtilsService.showErorr("Vui lòng nhập lý do không duyệt");
				return;
			}
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				var data = {
					BOMID 		: this.id_bom,
					LOAITHAOTAC : this.TinhTrang[10].value,
					NOIDUNG		: controls['GHICHU'].value ? controls['GHICHU'].value : ""
				};
				this.bom.gdkconfirm(data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		}
	}

	showAfterConfirm(_sophieu, res) {
		if (res && res.status === 1) {
			const message = 'Định mức nguyên vật liệu ' + _sophieu + ' cập nhật thành công';
			this.layoutUtilsService.showInfo(message);
			this.back();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	back() {
		this.dialogRef.close({

		});
	}

	getListTypeOfMerchandise(){
		this.DungChungService.listLoaiHH().subscribe( res => {
			if(!res || res.status == 0){
				this.layoutUtilsService.showErorr(res.error.message);
				return;
			}
			this.listTypeOfMerchandise = res.data ? res.data : [];
			this.changeDetectView();
		});
	}

	getListMerchandise(){

		this.loadingMer.next(true);
		this.DungChungService.layDanhSachHangHoaInit().subscribe( res => {
			if(!res || res.status == 0){
				this.layoutUtilsService.showErorr(res.error.message);
				this.loadingMer.next(false);
				return;
			}
			this.listMerchandises = res.data ? res.data : [];
			if(this.eachStage.value){
				this.eachStage.value.forEach((pr, index) =>{
					if(index == 0) this.updateCodeNameMer(pr);
					if(pr.childs){
						pr.childs.forEach(ch => {
							if(!pr.flagCT)
								this.updateCodeNameMer(ch);
						})
					}
				})
				this.eachStage.next([...this.eachStage.value]);
			}
			this.loadingMer.next(false);
			this.changeDetectView();
		});
	}

	getListUnit(){
		// this.DungChungService.getDSDonViTinh().subscribe( res => {
		// 	if(!res || res.status == 0){
		// 		this.layoutUtilsService.showErorr(res.error.message);
		// 		return;
		// 	}
		// 	this.listUnit = res.data ? res.data : [];
		// 	this.changeDetectView();
		// });
	}

	getListStage(){
		var params = new QueryParamsModel({}, 'asc', '', 0, 10, {}, true);
		this.serviceQTSX.getListGiaiDoan(params).subscribe(res => {
			if(!res || res.status == 0){
				this.layoutUtilsService.showErorr(res.error.message);
				return;
			}
			this.listStage = res.data ? res.data : [];
			if(this.url_current == 'them-moi') this.addBOXInitData();
			this.changeDetectView();
		})
	}

	getListDevice(){
		this.DungChungService.getListDevice().subscribe( res => {
			if(!res || res.status == 0){
				this.layoutUtilsService.showErorr(res.error.message);
				return;
			}
			this.listDevice = res.data ? res.data : [];
			this.changeDetectView();
		});
	}

	getListProductionArea(){
		var qrp = new QueryParamsModel({}, 'asc', '', 0, 10, {}, true);
		this.serviceQTSX.getListKVSX(qrp).subscribe( res => {
			if(!res || res.status == 0){
				this.layoutUtilsService.showErorr(res.error.message);
				return;
			}
			this.listProductionArea = res.data ? res.data : [];
			this.changeDetectView();
		});
	}

	getStageChild(_idStageParent: number){
		if(this.listStage && this.listStage.length > 0){
			let sortStage = this.listStage.sort((a, b) => {return b.ThuTuUuTien - a.ThuTuUuTien});
			let indexIdStage = sortStage.findIndex(x => x.Id == _idStageParent);
			if(indexIdStage > -1){
				let element = (indexIdStage + 1) >= sortStage.length ? null : sortStage[indexIdStage + 1];
				if(element) return {id_stage: element.Id, code_stage: element.Code};
			}
		}
		return {id_stage: 0, code_stage: "CT"};
	}

	filterListTypeOfMer(__key: string){
		if(!__key) __key = "";
		if(!this.listTypeOfMerchandise || this.listTypeOfMerchandise.length == 0) return [];
		return this.listTypeOfMerchandise.filter(x => x.TenLoaiHH.toLowerCase().indexOf(__key.toLowerCase()) > -1);
	}

	filterListMer(__kindOf: string, __key: string){
		if(!__key) __key = "";
		if(!__kindOf || !Number(__kindOf) || !this.listMerchandises || this.listMerchandises.length == 0) return [];
		return this.listMerchandises.filter(x => +x.IdLoaiHH == +__kindOf && (x.TenHH.toLowerCase().indexOf(__key.toLowerCase()) > -1 || x.MaHH.toLowerCase().indexOf(__key.toLowerCase()) > -1));
	}

	getCodeMer(__idMer: number){
		if(!__idMer) return  {MaHH : "", TenHH : "", ListUnit : []};
		let __item = this.listMerchandises.find(x => x.IdHH == +__idMer);
		if(!__item) return  {MaHH : "", TenHH : "", ListUnit : []};
		return {MaHH : __item.MaHH, TenHH : __item.TenHH, ListUnit : __item.list_unit};
	}

	getCUnitInfor(_item: any){
		if(!_item.unitId) return  {TenDVT: "", Exchange: 0};
		let __item = _item.ListUnit.find(x => x.id_dvt == +_item.unitId);
		if(!__item) return {TenDVT: "", Exchange: 0};
		return {TenDVT: __item.name_dvt, Exchange: Number(_item.weight) * Number(__item.exchange)};
	}

	filterListUnit(__key: string){
		if(!__key) __key = "";
		if(!this.listUnit || this.listUnit.length == 0) return [];
		return this.listUnit.filter(x => x.TenDVT.toLowerCase().indexOf(__key.toLowerCase()) > -1);
	}

	filterListDevice(__key: string){
		if(!__key) __key = "";
		if(!this.listDevice || this.listDevice.length == 0) return [];
		return this.listDevice.filter(x => x.Ten.toLowerCase().indexOf(__key.toLowerCase()) > -1);
	}

	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputOfFormVNDInList(
		columnName: string,
		event: any,
		min: number = 0,
		item: any,
		index: number
	) {

		let _oldRatio = 0;
		let _newValue = event.target.value;
		let _item = columnName == "" ? item : item[columnName];
		if(_newValue == "" || _newValue.toString() == _item.toString()){
			event.target.value = _newValue == "" ? this.f_dynamic(min) : this.f_dynamic(_item);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");
			if (isNaN(tmpValue) || Number(tmpValue) < min) tmpValue = min;
			if (!_item) _item = tmpValue;
			if(columnName == "") this.req_quantification = +tmpValue;
			else item[columnName] = +tmpValue;
			event.target.value = this.f_dynamic(tmpValue);
		} else {
			if(columnName == "") this.req_quantification = +min;
			else item[columnName] = +min;
		}

		if(columnName == 'weight')
			this.updateUnitName(item);
		if(columnName == 'batch_quantification'){
			item.weight = item.batch_quantification;
			this.updateUnitName(item);
			//this.eachStage.value[index].performance = Number(this.calcPerformance(index));
			if(index == 0) this.eachStage.value[index].weight = Number(this.eachStage.value[index].batch_quantification);
		}
		this.changeDetect.detectChanges();
	}

	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ",") {
					count += 1;
				}
			}
		} else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ",") {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent
			? event.target.value.match(regex)
			: event.match(regex);

		if (found != null) {
			return false;
		}
		if (count >= 2) {
			return false;
		}
		return true;
	}

	updateCodeNameMer(_item: any, _remove: boolean = false){
		let infor = this.getCodeMer(_item.idMer);
		if(infor){
			_item.idMer = Number(_item.idMer);
			_item.nameMer = infor.TenHH;
			_item.codeMer = infor.MaHH;
			_item.ListUnit = [...infor.ListUnit];
			if(_remove){
				_item.unitId = 0;
				_item.unit = "";
				this.setCodeNameUnitOfParent(_item);
			}
		}
		this.changeDetectView();
	}

	updateUnitName(_item: any){
		let infor = this.getCUnitInfor(_item);
		if(infor){
			_item.unitId = Number(_item.unitId);
			_item.unit = infor.TenDVT;
			_item.exchange = infor.Exchange;
			this.setCodeNameUnitOfParent(_item);
		}
		else
		{
			_item.unitId = 0;
			_item.unit = "";
			_item.exchange = 0;
		}
	}

	updateRecord(_indexEach: number, _indexChild: number){

	}

	updateRoot(){
		this.loadTree(this.eachStage.value[0], false);
	}

	addRecord(i: number){
		if(this.eachStage.value[i].childs == null) this.eachStage.value[i].childs = [];
		let object = {};
		object["bOMNumber"] =  null;
		object["idBTPParent"] = this.eachStage.value[i].idBTP;
		object["idBOM"] =  0;
		object["idBTP"] =  Math.abs(this.eachStage.value[i].idBTP) * (-1) -1;
		object["idMer"] =  0;
		object["codeMer"] =  "";
		object["nameMer"] =  "";
		object["weight"] =  0;
		object["unitId"] =  0;
		object["unit"] =  "";
		object["childs"] =  null;
		object["creator"] =  this.eachStage.value[i].creator;
		object["date"] =  this.eachStage.value[i].date;
		object["performance"] =  this.eachStage.value[i].performance;
		object["group"] =  "";
		object["flagCT"] =  this.eachStage.value[i].flagCT;
		object["prior"] =  0;
		object["exchange"] =  0;
		object["idTypeOf"] =  0;
		object["keyListTypeOf"] =  "";
		object["keyListMer"] =  "";
		object["keyListQTSX"] =  "";
		object["keyListDevice"] =  "";
		object["keyListUnit"] =  "";
		object["ListUnit"] = [];
		object["isClick"] =  false;
		object["groupId"] =  0;
		object["productivity"] = 0;
		let inforGroup = this.getStageChild(this.eachStage.value[i].groupId);
		object["group"] = inforGroup.code_stage;
		object["groupId"] = inforGroup.id_stage;
		this.eachStage.value[i].childs.push(object);
		this.eachStage.value[i].childs = [...this.eachStage.value[i].childs];
		let newEachStage = this.eachStage.value;
		this.eachStage.next([...newEachStage]);
		this.changeDetect.detectChanges();
	}

	addParent(_indexParent: number, _indexChild: number){
		let inforGroup = this.getStageChild(this.eachStage.value[_indexParent].groupId);
		this.eachStage.value[_indexParent].childs[_indexChild].group = inforGroup.code_stage;
		this.eachStage.value[_indexParent].childs[_indexChild].groupId = inforGroup.id_stage;
		this.eachStage.value[_indexParent].childs[_indexChild].childs = [];
		this.eachStage.value[_indexParent].childs[_indexChild].keyListDevice = "";
		this.eachStage.value[_indexParent].childs[_indexChild].devices = [];
		this.eachStage.value[_indexParent].childs[_indexChild].batch_quantification = 0;
		this.eachStage.value[_indexParent].childs[_indexChild].performance = 0;
		this.eachStage.value.push(this.eachStage.value[_indexParent].childs[_indexChild]);
		let newEachStage = this.eachStage.value;
		this.eachStage.next([...newEachStage]);
		this.changeDetect.detectChanges();
	}

	runUpdateNode(_item: any){

		const UPDATE_NODE = 1; // fixed variable edit
		let newTree = this.runViewTree(_item.idBTPParent, this.fullDataAPI, _item, UPDATE_NODE);
		this.fullDataAPI = {...newTree};
		this.handleCaculate(newTree.weight);
		this.changeDetect.detectChanges();
	}

	clearParent(evt){
		let arrRemove = this.clearParentLoop(evt);
		this.eachStage.next(this.eachStage.value.filter((x, index) => arrRemove.indexOf(index) == -1));
		this.changeDetect.detectChanges();
	}

	clearParentLoop(evt: any){
		let _arr = [evt];
		let _item = this.eachStage.value[evt];
		let _indexArr = this.eachStage.value.filter(x => x.idBTPParent == _item.idBTP).map(x => this.eachStage.value.indexOf(x));
		_indexArr.forEach(_index => {
			if(_index > -1){
				let arrChild = this.clearParentLoop(_index);
				_arr = [..._arr, ...arrChild];
			}
		})
		return _arr;
	}

	clearChild(_indexParent: number, _indexChild: number){
		this.eachStage.value[_indexParent].childs = this.eachStage.value[_indexParent].childs.filter((x, index) => index !== _indexChild);
		this.changeDetect.detectChanges();
	}

	runDeleteNodeTree(_idParentBTP: number, _indexChild: number, _node: any){
		if(_node == null) return;
		if(_node.idBTP == _idParentBTP){
			if(_node.childs && _node.childs[_indexChild]){

				let _newChilds = _node.childs.filter((x, index) => _indexChild != index);
				if(_newChilds.length == 0) _node.childs = [];
				else _node.childs = [..._newChilds];
				this.fullDataAPI = {...this.fullDataAPI};
			}
		}
		if(_node.childs && _node.childs.length > 0){
			_node.childs.forEach(_nodeChild => this.runDeleteNodeTree(_idParentBTP, _indexChild, _nodeChild));
		}
	}

	runAddNodeTree(_idMer: number, _node: any, _item: any, _indexChild: number = -1){
		if(_node == null) return;
		let _temp = FunctionPublic.cloneObject(_node);
		_temp.childs = _node.childs && _node.childs.length ? [] : null;
		let _newNode = {..._temp};
		if(_node.childs && _node.childs.length > 0){
			_node.childs.forEach(_child => {
				let _tempChild = this.runAddNodeTree(_idMer, _child, _item, _indexChild);
				_newNode.childs.push(_tempChild);
			});
		}
		if(_idMer == _node.idMer){
			if(_newNode.childs == null) _newNode.childs = [];
			if(_indexChild == -1)
				_newNode.childs.push(_item);
			if(_indexChild > -1)
				_newNode.childs[_indexChild] = _item;
		}
		return _newNode;
	}

	// 0: add | 1: edit | 2: delete
	runViewTree(_id: number, _data: any, _item: any, _flag: number = 0){
		if(_data == null) return [];
		let _temp = FunctionPublic.cloneObject(_data);
		_temp.childs = _data.childs ? [] : null;
		let _object = {..._temp};
		if(_data.childs && _data.childs.length > 0){
			_data.childs.forEach(_child => {
				let _tempChild = this.runViewTree(_id, _child, _item, _flag);
				if(_tempChild){
					if(_item.idBTPParent == _id && _item.idMer == _tempChild.idMer && _item.groupId == _tempChild.groupId){

						if(_flag == 1) _tempChild = {..._item};
						if(_flag != 1) _tempChild.childs = _flag == 0 ? [] : null;
						_tempChild.group = _item.group;
						_tempChild.groupId = _item.groupId;
					}
					_object.childs.push(_tempChild);
				}
			});
		}
		return _object;
	}

	addBOXInitData(){
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		let _groupPQ = this.listStage.length == 0? null : this.listStage.sort((a, b) => {return b.ThuTuUuTien - a.ThuTuUuTien})[0];
		let _roof = {
			"bOMNumber": "",
			"idBOM": 0,
			"idBTPParent": 0,
			"idBTP": -1,
			"idMer": 0,
			"codeMer": "",
			"nameMer": "",
			"weight": 1,
			"unitId": 0,
			"unit": "",
			"childs": null,
			"creator": tenNguoiLap,
			"date": moment(new Date()).format("YYYY-MM-DD"),
			"performance": 0,
			"group": _groupPQ == null ? '' : _groupPQ.Code,
			"groupId":  _groupPQ == null ? '' : _groupPQ.Id,
			"flagCT": false,
			"prior": _groupPQ == null ? '' : _groupPQ.ThuTuUuTien,
			"exchange": 0,
			"idTypeOf": 4,
			"nameTypeOf": "",
			"production_area_id": 0,
			"production_area_name" : "",
			"calc_performance" : false,
			"devices": [],
			"batch_quantification": 0,
			"productivity" : 0
		};
		this.eachStage.next([_roof]);
		this.master = {..._roof};
		if(this.eachStage.value.length > 0){
			this.eachStage.value[0].keyListTypeOf = "";
			this.eachStage.value[0].keyListMer = "";
			this.eachStage.value[0].keyListQTSX = "";
			this.eachStage.value[0].keyListUnit = "";
			this.eachStage.value[0].ListUnit = [];
			this.eachStage.value[0].keyListDevice = "";
		}
	}

	loadTree(_roof: any, setChildNull: boolean = true){
		this.fullDataAPI = {..._roof};
		this.handleCaculate(_roof.weight, setChildNull);
		this.changeDetect.detectChanges();
	}

	isEdit(){
		return this.url_current == 'them-moi' || this.url_current == 'chinh-sua';
	}

	isNextGroup(i: number){
		let inforGroup = this.getStageChild(this.eachStage.value[i].groupId);
		return inforGroup.id_stage > 0;
	}

	changedDevice(event: any){
		if(!event || event.length === 0) return [];
		return event.map(x => ''+x);
	}

	calcPerformance(index: number){
		let _itemParent = this.eachStage.value[index];
		let _performance = 0;
		if(_itemParent != null){
			let weight = Number(_itemParent.exchange);
			let childs = _itemParent.childs ? _itemParent.childs.filter(x => x.exchange && x.calc_performance).map(x => Number(x.exchange)).reduce((a, b) => {return a + b}, 0) : 0;
			_performance = childs > 0 ? weight / childs * 100.00 : 0;
		}
		return _performance;
	}

	updateJoinPerf(_indexParent: number, _indexChild: number, evt: any){
		this.eachStage.value[_indexParent].childs[_indexChild].calc_performance = evt? evt.checked : false;
		this.eachStage.value[_indexParent].performance = this.calcPerformance(_indexParent);
		this.eachStage.next(this.eachStage.value);
		this.changeDetect.detectChanges();
	}

	mergeData(){
		let rdBOM = {};
		if(this.eachStage.value.length > 0){
			let roof = this.eachStage.value[0];
			rdBOM["Id"] = +roof.idBOM;
			rdBOM["ThanhPhamId"] = Number(roof.idMer);
			rdBOM["ThanhPhamSl"] = Number(roof.batch_quantification);
			rdBOM["ListGiaiDoan"] = [];
			rdBOM["SoPhieu"] = "";
			rdBOM["TinhTrang"] = "";
			rdBOM["IdQTSX"] = Number(roof.production_process_id) && Number(roof.production_process_id) > 0 ? Number(roof.production_process_id) : null;
			// Lấy dữ liệu các node gốc
			let roofTemps =  this.eachStage.value.filter(x => !x.flagCT);
			roofTemps.forEach(roofTemp => {
				let rdBTP = {};
				rdBTP["BtpId"] = Number(roofTemp.idMer);
				rdBTP["Hieusuat"] = Number(roofTemp.performance);
				rdBTP["QtsxGiaidoanId"] = Number(roofTemp.groupId);
				rdBTP["QtsxGiaidoanId"] = Number(roofTemp.groupId);
				rdBTP["LaThanhPham"] = rdBOM["ListGiaiDoan"].length == 0;
				rdBTP["DinhLuongMe"] = Number(roofTemp.batch_quantification);
				rdBTP["DonViMe"] = Number(roofTemp.unitId);
				rdBTP["KhuVucSanXuatId"] = Number(roofTemp.production_area_id);
				rdBTP["NSNC"] = Number(roofTemp.productivity);
				rdBTP["NSTBThietBi"] = [];
				rdBTP["RdBoMCt"] = [];
				// Lấy dữ liệu chi tiết
				if(roofTemp.childs){
					let weightTotal = roofTemp.childs.map(x => +x.exchange).reduce((a, b) => {return a + b;}, 0);
					roofTemp.childs.forEach(child => {
						let rdBOMCt = {};
						rdBOMCt["ItemId"] = Number(child.idMer);
						rdBOMCt["BoMBTPId"] = Number(roofTemp.idBTP);
						rdBOMCt["KhoiLuongNguyenLieu"] = Number(child.weight);
						rdBOMCt["DonViNguyenLieu"] = Number(child.unitId);
						rdBOMCt["IsCoTinhHieuSuat"] = child.calc_performance;
						rdBOMCt["KhoiLuongQuyDoiSangKG"] = Number(child.exchange);
						rdBOMCt["TylephantramMe"] = Number(weightTotal) == 0 ? 0 : Number(child.exchange) / Number(weightTotal);
						// Add vào BOM chính
						rdBTP["RdBoMCt"].push(rdBOMCt);
					})
				}
				// Add vào BOM chính
				rdBOM["ListGiaiDoan"].push(rdBTP);
				// Lấy dữ liệu thiết bị
				if(roofTemp.devices.length > 0){
					roofTemp.devices.forEach(device =>{
						let rdBOMDevice = {};
						rdBOMDevice["ThietBiDinhMucId"] = Number(device);
						rdBOMDevice["BtpId"] = Number(roofTemp.idBTP);
						rdBTP["NSTBThietBi"].push(rdBOMDevice);
					});
				}
			})
		}
		return rdBOM;
	}

	saveDataUpdated(status: number = 0){
		// Kiểm tra dữ liệu
		var _flagValid = true;
		if(this.eachStage.value.length == 0){
			this.layoutUtilsService.showErorr("BOM không có dữ liệu");
			return;
		}
		let _listErrorChild = [];
		this.eachStage.value.forEach((each, index) => {
			if(!each.flagCT){
				if(each.childs == null) _listErrorChild.push(index + 1);
				else {
					let _sumCalcPer = each.childs.filter(x => x.calc_performance);
					if(_sumCalcPer.length == 0)  _listErrorChild.push(index + 1);
				}
			}
		});
		if(_listErrorChild.length > 0){
			this.layoutUtilsService.showErorr("Yêu cầu chọn ít nhất 1 dữ liệu đầu vào có tính hiệu suất theo thứ tự "+_listErrorChild.join(", "));
			return;
		}
		// Dữ liệu BOM chính
		let _bodyData = this.mergeData();
		if (status == 1 || status == 2) {
			_bodyData["TinhTrang"] = this.TinhTrang[1].value;
			const _sophieu: string = _bodyData["SoPhieu"];
			const dialogRef = this.layoutUtilsService.POP02();
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				if (_bodyData["Id"] > 0) {
					this.bom.edit(_bodyData).subscribe(res => this.runAfterAddOrUpdate(res, status))
				} else {
					this.bom.insert(_bodyData).subscribe(res => this.runAfterAddOrUpdate(res, status))
				}
			});
		}
		else {
			_bodyData["TinhTrang"] = this.TinhTrang[0].value;
			if (_bodyData["Id"] > 0) {
				this.bom.edit(_bodyData).subscribe(res => this.runAfterAddOrUpdate(res, status))
			} else {
				this.bom.insert(_bodyData).subscribe(res => this.runAfterAddOrUpdate(res, status))
			}
		}
	}
	runAfterAddOrUpdate(res, withBack) {

		if (res && res.status == 1) {
			const message = 'Định mức nguyên vật liệu cập nhật thành công';
			this.layoutUtilsService.showInfo(message);
			// Luu nháp
			if(withBack == 0){
				this.router.navigateByUrl('/cong-thuc-dinh-muc/chinh-sua/'+res.data.Id);
				this.changeDetect.detectChanges();
				return;
			}
			// Lưu và thêm mới
			if(withBack == 2){
				this.router.navigateByUrl('/cong-thuc-dinh-muc/them-moi');
				this.changeDetect.detectChanges();
				return;
			}
			// Lưu và trờ lại
			if(withBack == 1){
				this.back();
			}
			this.back();
		}
		else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}


	setDataPhanQuyen(evt: any, _indexParent: number){
		if(evt){
			this.eachStage.value[_indexParent].production_area_id = Number(evt);
			let element = this.listProductionArea.find(x => x.Id == +evt);
			if(element){
				this.eachStage.value[_indexParent].production_area_name = element.TenKhuVuc;
			}
			this.eachStage.value[_indexParent] = {...this.eachStage.value[_indexParent]};
		}
		this.changeDetect.detectChanges();
	}
	setDefaultMer(_item: any){
		_item.idMer = 0;
		_item.nameMer = "";
		_item.codeMer = "";
		_item.weight = 0;
		_item.ListUnit = [];
		_item.unit = "";
		_item.unitId = 0;
		this.changeDetect.detectChanges();
	}

	setCodeNameUnitOfParent(_item: any){
		let roofOfItem = this.eachStage.value.find(x => x.idBTP == _item.idBTP);
		if(roofOfItem){
			roofOfItem.idMer = _item.idMer;
			roofOfItem.codeMer = _item.codeMer;
			roofOfItem.nameMer = _item.nameMer;
			roofOfItem.unit = _item.unit;
			roofOfItem.unitId = _item.unitId;
		}
		this.changeDetect.detectChanges();
	}

	getListQTSX(){
		this.serviceQTSXs.listTPQTSXLite().subscribe( res => {
			if(!res || res.status == 0){
				this.layoutUtilsService.showErorr(res.error.message);
				return;
			}
			this.listQTSX = res.data ? res.data : [];
			this.changeDetectView();
		});
	}

	filterListQTSX(__idBTP: number, __key: string){
		if(!__key) __key = "";
		if(!__idBTP || !Number(__idBTP) || !this.listQTSX || this.listQTSX.length == 0) return [];
		return this.listQTSX.filter(x => +x.IdBTP == +__idBTP && (x.MaQTSX.toLowerCase().indexOf(__key.toLowerCase()) > -1));
	}

	changedProductionProcessName(evt, i: number){
		if(evt && +evt){
			this.eachStage.value[i].production_process_id = Number(evt);
			let _listPP = this.filterListQTSX(this.eachStage.value[i].idMer, "");
			if(_listPP && _listPP.length > 0){
				let _ppInfo = _listPP.find(x => x.IdQTSX);
				if(_ppInfo){
					this.eachStage.value[i].production_process_code = _ppInfo.MaQTSX;
					//this.eachStage.value[i].production_process_name = _ppInfo.TenQTSX;
				}
			}
		}
		else
		{
			this.eachStage.value[i].production_process_id = 0;
			this.eachStage.value[i].production_process_code = "";
			//this.eachStage.value[i].production_process_name = "";
		}
		this.eachStage.next([...this.eachStage.value]);
		this.changeDetectView();
	}

	f_dynamic(item: any = "0.0000", dynamic = 4){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, dynamic);
	}
}

